import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91ea3fdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-icons-list" }
const _hoisted_2 = {
  width: "20px",
  height: "20px",
  viewBox: "0 0 20 20",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "【2-ico】/3-应用/2-操作/1-增删改查/Btn3-改", -1))
const _hoisted_4 = {
  id: "【2-ico】/3-应用/2-操作/1-增删改查/Btn3-改",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}
const _hoisted_5 = ["fill"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Icon, {
      style: _normalizeStyle(_ctx.style),
      class: "icon"
    }, {
      component: _withCtx(() => [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("g", _hoisted_4, [
            _createElementVNode("path", {
              d: "M10.7894737,4 C11.0510822,4 11.2631579,4.24541858 11.2631579,4.50702715 C11.2631579,4.76863572 11.0510822,4.99481398 10.7894737,4.99481398 L5.80430057,4.99481398 C5.36828629,4.99481398 5.01482689,5.34827338 5.01482689,5.78428766 L5.01482689,14.2631579 C5.01482689,14.6991722 5.36828629,14.9984511 5.80430057,14.9984511 L14.2631579,14.9984511 C14.6991722,14.9984511 15.0070067,14.6449917 15.0070067,14.2089774 L15.0070067,9.05263158 C15.0070067,8.79102301 15.2190824,8.57894737 15.4806909,8.57894737 C15.7422995,8.57894737 16,8.79102301 16,9.05263158 L16,14.2631579 C16,15.2223684 15.2223684,16 14.2631579,16 L5.7368421,16 C4.77763157,16 4,15.2223684 4,14.2631579 L4,5.7368421 C4,4.77763157 4.77763157,4 5.7368421,4 L10.7894737,4 Z M15.5711413,4.0258301 C15.745956,4.07158782 15.9187925,4.24417836 15.9645502,4.41899308 C16.0103079,4.59380779 15.9581799,4.7797095 15.8282016,4.90524674 L8.75770163,11.9759134 C8.56242295,12.1711921 8.24581366,12.1711921 8.05053498,11.9759134 C7.8552563,11.7806347 7.81894233,11.4279574 8.01422101,11.2326787 L15.0848877,4.16234533 C15.2104249,4.03220038 15.3963266,3.98007238 15.5711413,4.0258301 Z",
              id: "形状结合",
              fill: _ctx.style.color
            }, null, 8, _hoisted_5)
          ])
        ]))
      ]),
      _: 1
    }, 8, ["style"])
  ]))
}